import { getCollapsiblePanelStyles } from '../../shared/styles';
import { disclaimerSettingsStyles, disclaimerPanelStyles } from './components/styles/disclaimer-setting-styles';

export const getCampaignStyles = (components, theme) => ({
  divider: {
    padding: '5px 0px 0px 4px',
    width: '100%',
    borderTop: '2px solid #E0E0E0',
    marginTop: 30,
    marginBottom: 20,
  },
  budgetContainer: {
    '& .budget-title-container span': {
      fontWeight: 600,
    },
  },
  campaignShell: {
    display: 'flex',
    width: 966,
    '& .multi-selector': {
      maxWidth: 888,
    },
    '& .collapse-panel.disclaimer': {
      '& .collapse-content': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    '& .deal-impression-container': {
      marginLeft: 8,
    },
    '& .device-target .collapse-title-bar .title-item .collapse-title': {
      marginLeft: '8px',
    },
  },
  collapsiblePanel: getCollapsiblePanelStyles(components, theme),
  estimationPart: {
    flexGrow: '1',
    position: 'sticky',
    marginTop: '58px',
    marginLeft: '30px',
  },
  disclaimerContainerWrapper: disclaimerSettingsStyles(theme),
  '@global': {
    ...disclaimerPanelStyles(theme),
  },
});
